import React from 'react';
import { Label, Input, InputGroup, InputGroupText } from 'reactstrap';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

function InputGroupAddon({ className, children, style, addonType = 'prepend' }) {
  const prependClassName = addonType === 'prepend' ? '-mr-[1px]' : '-ml-[1px]';
  return (
    <div className={cx(className, 'flex', prependClassName)} style={style}>
      {children}
    </div>
  );
}

function FormGroup({ className, children, ...props }) {
  return (
    <div className={twMerge(className, 'form-group w-full mb-4')} {...props}>
      {children}
    </div>
  );
}

export { FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText };
